import { useParams } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import CategoryApi from '../../../lib/api/category/CategoryApi';
import { CATEGORY } from '../../../constants/queryKeys';

const useCreateSubCategory = () => {
  const { id } = useParams();

  const queryClient = useQueryClient();

  const createSubCategory = useMutation({
    mutationFn: ({ data }) => CategoryApi.createSubCategory(id, data),
    onSuccess: async () => {
      try {
        // invalidateQueries 하게 될 경우 화면 깜빡임이 있어
        // 먼저 데이터를 가져온 다음 setQueryData 처리
        const result = await CategoryApi.getSubCategoryList(id);
        queryClient.setQueryData([...CATEGORY.SUB_CATEGORY_LIST, id], result);
      } catch (e) {
        console.error(e);
      }
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { createSubCategory };
};

export default useCreateSubCategory;
